let _alert = null;
let _confirm = null;

export const modalService = {
  register(alert, confirm) {
    _alert = alert;
    _confirm = confirm;
  },

  alert(options) {
    if (!_alert) return Promise.resolve(true);
    return _alert.show(options);
  },

  confirm(options) {
    if (!_confirm) return Promise.resolve(false);
    return _confirm.show(options);
  },
};
